export default __webpack_public_path__ + "static/media/PHETSARATH OT.2dc2c772.TTF";